<template>
  <div class="animated fadeIn">
    <div id="custom_backdrop"></div>
    <div class="row pageinfo">
      <b-col lg="6">
        <h2>Logs</h2>
      </b-col>

      <!--Gear Icon-->
      <b-col lg="6">
        
        <download-excel
            :data   = "items"
            :fields = "json_fields"
            type    = "csv"
            :name   = "filename">
            <b-btn class="pull-right" v-b-popover.hover.top="'Export to csv'" variant="info"><i class="fa fa-file-excel-o"></i></b-btn>
        </download-excel>
      </b-col>
    </div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <b-container fluid>
            <!-- Main table element -->
            <b-row class="justify-content-between">
              <b-col md="4" class="my-1">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <b-form-input v-model="filter" placeholder="Search" />
                    <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                  </div>
                </div>
              </b-col>
              <b-col lg="5" class="my-1">
                
              </b-col>
            </b-row>
           <!-- Shows when loading data-->
            <b-row v-if="loadingData">
              <b-col cols="12" sm="12" md="12" lg="12">
                <p class="text-center"> <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br> Loading data... </p>
              </b-col>
            </b-row>
            <!-- End Main table Elements-->
            <b-table v-if="!loadingData" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" @row-clicked="rowClicked">
              <template  slot="select_log" slot-scope="row">
                <b-form-checkbox id="checkbox" @click.native.stop  @change="checkedField(row)">
                </b-form-checkbox>
              </template>
            </b-table>
           <!-- User Interface controls -->
            <b-row>
              <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend"> </div>
                  <b-select :options="pageOptions" v-model="perPage" />
                </div>
              </b-col>
              <b-col lg="10" md="10" sm="12" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
              </b-col>
            </b-row>
            <!-- End User Interface controls-->
          </b-container>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import logs_service from './logs_service'
  import moment from 'moment';
  import users_service from '../users/users_service'

  Vue.use(VueSweetalert2)

  const items = []
  export default {
    name: 'logs',
    created: function() {
      //this.getFilters()
      localStorage.removeItem("logsaPage");
      localStorage.removeItem("locationsaPage");
      localStorage.removeItem("tagetsaPage");
      localStorage.removeItem("targetPage");
      localStorage.removeItem("taPage");
      localStorage.removeItem("tpPage");
      localStorage.removeItem("oasaPage");
      localStorage.removeItem("oaPage");
      localStorage.removeItem("reportPage");
      localStorage.removeItem("rolesPage");
      localStorage.removeItem("servicePage");
      localStorage.removeItem("tasaPage");
      localStorage.removeItem("tcPage");
      localStorage.removeItem("locationPage");
      localStorage.removeItem("truckPage");
      localStorage.removeItem("userPage");
      if (!localStorage.logPage) {
          localStorage.logPage = 0;
      }
      this.getAll()
    },
    data() {
      return {
        filename : 'logs_report_'+moment().format('YYYYMMDDHHMM')+'.csv',
        json_fields: {
          "log_id":"id",
          "log_error":"error",
          "log_service":"service",
          "log_user":"user",
          "log_client":"client",
          "log_generated_at":"generated_at"
       },
       json_data: [],
       json_meta: [
           [
               {
                   'key': 'charset',
                   'value': 'utf-8'
               }
           ]
       ],
       
        status:'unchecked',
        insert_data: null,
          log_ids:[],
          selected: '',
        row: 0,
        loadingData: true,
        trash: false,
        items: items,
        items: items,
        totalRows: items.length,
        v_items:null,
        fieldsSelected: 8,
        maxFieldsSelected: 10,
        tempFields: [],
        fields: [
           {
          key: 'id',
          label: 'Id',
          sortable: true
        }, {
          key: 'error',
          label: 'Error',
          sortable: true
        }, {
          key: 'service',
          label: 'Service',
          sortable: true
        }, {
          key: 'user',
          label: 'User',
          sortable: true
        }, {
          key: 'client',
          label: 'Client',
          sortable: true,
        }, {
          key: 'generated_at',
          label: 'Generated At',
          sortable: true
        },{
          key: 'is_resolved',
          label: 'Status',
          sortable: true,
          formatter: (value) => { return value ? 'Solved' : 'Not Solved' }
        }],
        currentPage: parseInt(localStorage.logPage),
        perPage: 25,

        pageOptions: [25, 50, 100],
        sortBy: 'id',
        sortDesc: true,
        filter: null,
        modalInfo: {
          title: '',
          content: ''
        },
        modalEdit: {
          title: ''
        },
        selectedItems: [
          'log_id',
          'log_error',
          'log_service',
          'log_user',
          'log_client',
          'log_generated_at'
        ],
				role:'',
				view:true,
        view1:true,
				savebtn:true,
				energy_company_id :null,
        unit:''
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })

      }
    },
    methods: {
      
      onFiltered(filteredItems) {
        this.currentPage = parseInt(localStorage.logPage)
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      rowClicked(row) {
				  	localStorage.rolesPage = this.currentPage;
        		localStorage.setItem('xyz', row.id)
        		this.$router.push('/log/' + row.id + '/')
      	},
     getAll () {
        this.loadingData = true
        logs_service.getAll()
          .then(data => {
                if (data[0] == 'success') {
									this.items = data[1]                
                } else {
                  this.items = []
                  this.$swal(data[0], data[1], data[0])
                }
                this.loadingData = false
          })
          .catch(error => {
            this.$swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      }
  }
}
</script>

<style>
  .table tbody tr:hover {
    background-color: rgb(222, 225, 229);
    color: #030303;
    cursor: pointer;
  }

  table div {
    padding: 0.75rem;
  }

  .table td {
    padding: 0 !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/logs/logs.vue